"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralEnquiryResponseDtoStatusEnum = exports.GeneralEnquiryResponseDtoEnquiryTypeEnum = void 0;
exports.instanceOfGeneralEnquiryResponseDto = instanceOfGeneralEnquiryResponseDto;
exports.GeneralEnquiryResponseDtoFromJSON = GeneralEnquiryResponseDtoFromJSON;
exports.GeneralEnquiryResponseDtoFromJSONTyped = GeneralEnquiryResponseDtoFromJSONTyped;
exports.GeneralEnquiryResponseDtoToJSON = GeneralEnquiryResponseDtoToJSON;
exports.GeneralEnquiryResponseDtoToJSONTyped = GeneralEnquiryResponseDtoToJSONTyped;
var GeneralEnquiryDetailsDto_1 = require("./GeneralEnquiryDetailsDto");
/**
 * @export
 */
exports.GeneralEnquiryResponseDtoEnquiryTypeEnum = {
    Inspection: 'inspection',
    DocumentRequest: 'document_request',
    GeneralEnquiry: 'general_enquiry',
    ListingCrmEnquiry: 'listing_crm_enquiry',
    PropertyValuation: 'property_valuation',
    ListProperty: 'list_property'
};
/**
 * @export
 */
exports.GeneralEnquiryResponseDtoStatusEnum = {
    InProgress: 'in_progress',
    Open: 'open',
    Resolved: 'resolved'
};
/**
 * Check if a given object implements the GeneralEnquiryResponseDto interface.
 */
function instanceOfGeneralEnquiryResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('enquiryId' in value) || value['enquiryId'] === undefined)
        return false;
    if (!('enquiryType' in value) || value['enquiryType'] === undefined)
        return false;
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('generalEnquiry' in value) || value['generalEnquiry'] === undefined)
        return false;
    return true;
}
function GeneralEnquiryResponseDtoFromJSON(json) {
    return GeneralEnquiryResponseDtoFromJSONTyped(json, false);
}
function GeneralEnquiryResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'enquiryId': json['enquiryId'],
        'enquiryType': json['enquiryType'],
        'userId': json['userId'],
        'receiverId': json['receiverId'] == null ? undefined : json['receiverId'],
        'status': json['status'],
        'createdAt': (new Date(json['createdAt'])),
        'generalEnquiry': (0, GeneralEnquiryDetailsDto_1.GeneralEnquiryDetailsDtoFromJSON)(json['generalEnquiry']),
    };
}
function GeneralEnquiryResponseDtoToJSON(json) {
    return GeneralEnquiryResponseDtoToJSONTyped(json, false);
}
function GeneralEnquiryResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'enquiryId': value['enquiryId'],
        'enquiryType': value['enquiryType'],
        'userId': value['userId'],
        'receiverId': value['receiverId'],
        'status': value['status'],
        'createdAt': value['createdAt'].toISOString(),
        'generalEnquiry': (0, GeneralEnquiryDetailsDto_1.GeneralEnquiryDetailsDtoToJSON)(value['generalEnquiry']),
    };
}
